/**
 * @file
 * @prettier
 */

import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";

export function InitializeRTSStep0Page() {
  customValidationInit(true);
  aspControlValidationInit();
}
